import { cookiesConsentSeen, initGTag } from '@/services/ga-tracking';
import { useEffect, useState } from 'react';
import CookieBanner from './index';

const CookieWrapper = (_props: {}) => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if (!cookiesConsentSeen()) {
      setShowBanner(true);
    }
  }, []);

  useEffect(() => {
    initGTag();
  }, []);

  return showBanner && <CookieBanner />;
};

export default CookieWrapper;
